const state = {
  size: ''
};

const getters = {
  windowSizeGetter: state => state.size
};

export default {
  namespaced: true,
  state,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/window.js